<template>
  <div>
    <div class="ft-22-333">我的授课</div>
    <div class="se-flex se-m-t-20 se-m-b-20">
      <!-- <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          index === 0 ? 'active' : '',
        ]"
        @click="index = 0"
      >
        全部
      </div> -->
      <!-- <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          index === 1 ? 'active' : '',
        ]"
        @click="index = 1"
      >
        已完成
      </div>
      <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          index === 2 ? 'active' : '',
        ]"
        @click="index = 2"
      >
        进行中
      </div>
      <div
        :class="['se-btn', 'cp', 'ft-16-333', index === 3 ? 'active' : '']"
        @click="index = 3"
      >
        待开始
      </div> -->
    </div>
    <div class="se-list se-p-t-10" v-loading="loading">
      <div
        class="se-item se-flex cp cell"
        v-for="(item, index) in courseList"
        :key="index"
        @click="goInfo(item)"
      >
        <img
          :src="item.coverUrl || require('../../../assets/images/studyC.png')"
          style="width: 190px; height: 130px"
        />
        <div class="se-p-t-5 se-p-b-5 se-msg se-m-l-20">
          <!-- <div class="ft-16-333-b">道路施工优秀课程3</div> -->
          <div class="ft-16-333-b">{{ item.courseName }}</div>
          <div class="ft-14-999-b">
            <!-- 道路施工讲究四点要素，记住这四点要素，让你道路施工进度...... -->
            {{ item.courseSummary }}
          </div>
          <div class="ft-14-999">时间：{{ item.passTime }}</div>
          <img
            src="../../../assets/icons/status2.png"
            style="width: 62px; height: 29px"
          />
        </div>
      </div>
    </div>
    <div class="se-flex-h-c">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 0,
      courseList: [], //课程列表
      pageNum: 1,
      pageSize: 5,
      total: 0,
      loading: false,
    };
  },
  created() {
    this.getMyCourseList();
  },
  methods: {
    // 分页回调
    currentChange(val) {
      this.pageNum = val;
      this.getMyCourseList();
    },

    goInfo(item) {
      // this.$router.push({ name: "courseInfo", query: { type: "course" } });
      this.$router.push({
        name: "courseInfo",
        query: {
          type: "course",
          courseId: item.id,
          teacherId: item.teacherId,
          t: new Date().getTime(),
        },
      });
    },
    go() {
      this.$router.push({ name: "courseInfo", query: { type: "course" } });
    },
    //我的课程
    getMyCourseList() {
      this.loading = true;
      let token = localStorage.getItem("token");
      this.$http
        .get(
          "server/portal/personCenter/myCourseList",
          {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          },
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          this.courseList = res.rows;
          this.total = res.total;
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.se-btn {
  width: 128px;
  height: 35px;
  border-radius: 16px;
  line-height: 35px;
  text-align: center;
  font-size: 16px;
  background-color: #f6f7f9;
}

.active {
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.09);
  color: #f41539;
  background-color: #fff;
}

.se-msg {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cell {
  margin-bottom: 30px;
}

.ft-14-999-b {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
